import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "NewsArticleLike",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const {
  postNewsArticleLike,
  postNewsArticleLikeError,
  postNewsArticleLikeSuccess,
} = slice.actions;

reducerRegistry.register("newsArticleLike", reducer);
